import React from 'react';
import DialogsAPI from 'api/DialogsAPI';
import TrackingAPI from 'api/TrackingAPI';
import NiceConfirm from 'components/modals/NiceConfirm';
import { successAlert } from 'ui-kit/Alert';


const DeleteMessageConfirmModal = (props) => {
  const {
    isOpen,
    dialogId,
    deletingIndex,
    setDeletingIndex,
    scenario,
    game,
    setBatches,
    setSending,
    setUpdT
  } = props;

  if (!isOpen || deletingIndex === undefined) return null;


  const analyticsData = {
    config_name: scenario?.name,
    scenario_name: game?.name,
    dialogId: dialogId
  };

  const handleConfirm = async () => {
    setBatches([]);
    setSending(true);

    await DialogsAPI.deleteBatch(dialogId, +deletingIndex);

    setUpdT(+new Date());
    setSending(false);
    setDeletingIndex(undefined);
    successAlert('Dialog messages have been deleted');

    TrackingAPI.trackEvent('batch_deleted', analyticsData);
  };

  const handleCancel = () => {
    setDeletingIndex(undefined);
  };

  return (
    <NiceConfirm
      confirmText={'Yes'}
      cancelText={'No'}
      loading={false}
      heading={<div className='font-["Raleway"]'>Delete messages</div>}
      subHeading={
        <div className="flex w-full justify-center">
          <p className="w-full max-w-[230px] text-center text-base leading-[18px]">
            Are you sure you want to delete messages?
          </p>
        </div>
      }
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
};

export default DeleteMessageConfirmModal;
